import { render } from "./List.vue?vue&type=template&id=2f40eacf"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Targets/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f40eacf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f40eacf', __exports__)) {
    api.reload('2f40eacf', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=2f40eacf", () => {
    api.rerender('2f40eacf', render)
  })

}


export default __exports__